module.exports = __webpack_public_path__ + "static/img/dummy-img.10707c0.jpg";